module.exports = __webpack_public_path__ + "static/media/refresh.b53d4066.jpg";